import React from 'react';

import { FeaturedPractitioners_featuredPractitioners_edges_node as PractitionersEdgeNode } from 'Services/BeGateway/Practitioner/__generated__/featuredPractitioners';

import { useFeaturedPractitioners } from 'Book/shared/hooks';
import { PractitionerCardListProps } from '../PractitionerCardList';
import { PractitionerCardListBase } from './PractitionerCardListBase';

export const FeaturedPractitionerCardList = ({
  limit = 4,
  trackingEvent,
}: Omit<
  PractitionerCardListProps,
  'featured' | 'filters' | 'lastAddedFilterKey' | 'onRemoveFilter'
>) => {
  const { data, loading, error, refetch } = useFeaturedPractitioners({ limit });

  const practitioners: PractitionersEdgeNode[] =
    (data?.featuredPractitioners?.edges
      ?.map(edge => edge?.node)
      .filter(Boolean) as PractitionersEdgeNode[]) ?? [];

  return (
    <PractitionerCardListBase
      trackingEvent={trackingEvent}
      practitioners={practitioners}
      hasFilters={false}
      loading={loading}
      error={!!error}
      refetch={refetch}
      singleRow={true}
    />
  );
};
